// Article types - includes ArticleItem, ArticleCategoryItem, and ArticleDataWithRelations
// Follows type cleanup guidelines with Prisma schema alignment
export * from "./article";

// Content types for user-generated content and related metadata
export * from './project'; // Project and gallery content types with category management

export * from './author';

export * from './content';

export * from './location';

// Target polymorphic types for content relationships
export * from './target';

